<template>
  <div class="index">
    <div class="advertisementBox">
      <ul>
        <li v-for="(x,i) in advertisementImg" :key="i" style="margin-bottom:15px">
          <img  v-if="x.routerpage == ''" :width="imgwidth" :height="imgheight" :title="x.title" :src="x.src" :href="x.href" :alt="x.alt" />
          <img  v-else :width="imgwidth" :height="imgheight" :title="x.title" :src="x.src" @click="goRouter(x.routerPage)" :alt="x.alt" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props:["imgwidth","imgheight"],
  data() {
    return {
      advertisementImg:[
        {title:"",src:"http://cd-jinchen-public.oss-cn-zhangjiakou.aliyuncs.com/5f0e5626a792c81e81ee9b55.jpg",href:"",routerPage:"",alt:"广告1"},
        {title:"",src:"http://cd-jinchen-public.oss-cn-zhangjiakou.aliyuncs.com/5f0e5626a792c81e81ee9b55.jpg",href:"",routerPage:"",alt:"广告2"},
        {title:"",src:"http://cd-jinchen-public.oss-cn-zhangjiakou.aliyuncs.com/5f0e5626a792c81e81ee9b55.jpg",href:"",routerPage:"",alt:"广告3"},
        {title:"",src:"http://cd-jinchen-public.oss-cn-zhangjiakou.aliyuncs.com/5f0e5626a792c81e81ee9b55.jpg",href:"",routerPage:"",alt:"广告4"},
        {title:"",src:"http://cd-jinchen-public.oss-cn-zhangjiakou.aliyuncs.com/5f0e5626a792c81e81ee9b55.jpg",href:"",routerPage:"",alt:"广告5"},
        {title:"",src:"http://cd-jinchen-public.oss-cn-zhangjiakou.aliyuncs.com/5f0e5626a792c81e81ee9b55.jpg",href:"",routerPage:"",alt:"广告6"},
        {title:"",src:"http://cd-jinchen-public.oss-cn-zhangjiakou.aliyuncs.com/5f0e5626a792c81e81ee9b55.jpg",href:"",routerPage:"",alt:"广告7"},
      ],
    }
  },
  methods:{
    goRouter(routerPage) {
      console.log(routerPage)
    }
  },
}
</script>
<style lang='scss' scoped>
.advertisementBox{
  width: 100%;
}
.advertisementBox img{
  width: 100%;
}
</style>